import { useParams } from 'react-router-dom'
import React, { useContext } from 'react'
import { com } from '@eidu/form'
import { EntityTypesContext } from '../../../io/context/EntityTypes'
import ManageEntityTypePage from '../ManageEntityTypePage'
import entityTypeIdFromString = com.eidu.sharedlib.entity.type.entityTypeIdFromString

export const ConfigurePageRoute = () => {
  const params = useParams()
  const entityTypeRepository = useContext(EntityTypesContext)

  if (params.entityTypeId)
    return (
      <ManageEntityTypePage
        entityTypeId={entityTypeIdFromString(params.entityTypeId)}
        entityTypeRepository={entityTypeRepository}
      />
    )
  else return <ManageEntityTypePage entityTypeId={undefined} entityTypeRepository={entityTypeRepository} />
}

export default ConfigurePageRoute
